import {
  sendConfirmEmailAction,
  SendConfirmEmailActionParams,
} from '@/actions/users/send-confirm-email-action/index'
import { useMutation } from '@tanstack/react-query'
export const useSendConfirmEmail = () => {
  return useMutation({
    mutationFn: async (params: SendConfirmEmailActionParams) => {
      const result = await sendConfirmEmailAction(params)
      if (result.type === 'error') {
        throw new Error(result.error)
      }
      return result
    },
  })
}
